import Service from './service'
export var DriveMessageType;
(function (DriveMessageType) {
  DriveMessageType["DRIVE_MODE_MANUAL"] = "DRIVE_MODE_MANUAL"
  DriveMessageType["DRIVE_MODE_AUTO"] = "DRIVE_MODE_AUTO"
  DriveMessageType["DRIVE_STATUS_IDLE"] = "DRIVE_STATUS_IDLE"
  DriveMessageType["DRIVE_STATUS_START"] = "DRIVE_STATUS_START"
  DriveMessageType["DRIVE_STATUS_CANCEL"] = "DRIVE_STATUS_CANCEL"
  DriveMessageType["DRIVE_STATUS_FINISH"] = "DRIVE_STATUS_FINISH"
  DriveMessageType["DRIVE_STATUS_OBSTACLE"] = "DRIVE_STATUS_OBSTACLE"
  DriveMessageType["DRIVE_CHARGE_STATUS_IDLE"] = "DRIVE_CHARGE_STATUS_IDLE"
  DriveMessageType["DRIVE_CHARGE_STATUS_SUCCESS"] = "DRIVE_CHARGE_STATUS_SUCCESS"
  DriveMessageType["DRIVE_CHARGE_STATUS_FAIL_CONNECT"] = "DRIVE_CHARGE_STATUS_FAIL_CONNECT"
  DriveMessageType["DRIVE_CHARGE_STATUS_FAIL_FIND_MARKER"] = "DRIVE_CHARGE_STATUS_FAIL_FIND_MARKER"
})(DriveMessageType || (DriveMessageType = {}))
export var ApiDriveMessageType;
(function (ApiDriveMessageType) {
  ApiDriveMessageType["DRIVE_STATUS"] = "system.drive.status"
  ApiDriveMessageType["DRIVE_MODE"] = "system.drive.mode"
  ApiDriveMessageType["DRIVE_CHARGE"] = "system.drive.charge"
  ApiDriveMessageType["DRIVE_CONTROL"] = "system.drive.control"
})(ApiDriveMessageType || (ApiDriveMessageType = {}))
export var DriveMode;
(function (DriveMode) {
  /** Ручное управление. Движение только с помощью удалённого контроля (джойстик, телеприсутствие и т.п.) */
  DriveMode[DriveMode["MANUAL"] = 0] = "MANUAL"
  /** Автономное передвижение */
  DriveMode[DriveMode["AUTONOMOUS"] = 1] = "AUTONOMOUS"
})(DriveMode || (DriveMode = {}))
export var DriveStatus;
(function (DriveStatus) {
  DriveStatus[DriveStatus["Idle"] = 0] = "Idle"
  DriveStatus[DriveStatus["Start"] = 1] = "Start"
  DriveStatus[DriveStatus["Finish"] = 2] = "Finish"
  DriveStatus[DriveStatus["Cancel"] = 3] = "Cancel"
  /** Препятствие */
  DriveStatus[DriveStatus["Obstacle"] = 4] = "Obstacle"
})(DriveStatus || (DriveStatus = {}))
export var DriveCharge;
(function (DriveCharge) {
  DriveCharge[DriveCharge["Idle"] = -1] = "Idle"
  DriveCharge[DriveCharge["Success"] = 0] = "Success"
  DriveCharge[DriveCharge["FailConnect"] = 1] = "FailConnect"
  DriveCharge[DriveCharge["FailFindMarker"] = 2] = "FailFindMarker"
})(DriveCharge || (DriveCharge = {}))
/**
 * Сервис для управления движением робота
 * @version 0.0.1
 * @since 2.0.0
 */
export default class DriveService extends Service {
  constructor(messageChannel) {
    super(messageChannel)
    this.driveStatusMap = new Map()
      .set(DriveStatus.Idle, DriveMessageType.DRIVE_STATUS_IDLE)
      .set(DriveStatus.Start, DriveMessageType.DRIVE_STATUS_START)
      .set(DriveStatus.Finish, DriveMessageType.DRIVE_STATUS_FINISH)
      .set(DriveStatus.Cancel, DriveMessageType.DRIVE_STATUS_CANCEL)
      .set(DriveStatus.Obstacle, DriveMessageType.DRIVE_STATUS_OBSTACLE)
    this.driveModeMap = new Map()
      .set(DriveMode.MANUAL, DriveMessageType.DRIVE_MODE_MANUAL)
      .set(DriveMode.AUTONOMOUS, DriveMessageType.DRIVE_MODE_AUTO)
    this.driveChargeMap = new Map()
      .set(DriveCharge.Idle, DriveMessageType.DRIVE_CHARGE_STATUS_IDLE)
      .set(DriveCharge.Success, DriveMessageType.DRIVE_CHARGE_STATUS_SUCCESS)
      .set(DriveCharge.FailConnect, DriveMessageType.DRIVE_CHARGE_STATUS_FAIL_CONNECT)
      .set(DriveCharge.FailFindMarker, DriveMessageType.DRIVE_CHARGE_STATUS_FAIL_FIND_MARKER)
    this.messageChannel.subscribe(ApiDriveMessageType.DRIVE_STATUS, this.onDriveStatus.bind(this))
    this.messageChannel.subscribe(ApiDriveMessageType.DRIVE_MODE, this.onDriveMode.bind(this))
    this.messageChannel.subscribe(ApiDriveMessageType.DRIVE_CHARGE, this.onDriveCharge.bind(this))
  }
  onDriveStatus({ status }) {
    const messageType = this.driveStatusMap.get(status)
    this.sendMessageType(messageType)
  }
  onDriveMode({ mode }) {
    const messageType = this.driveModeMap.get(mode)
    this.sendMessageType(messageType)
  }
  onDriveCharge({ charge }) {
    const messageType = this.driveChargeMap.get(charge)
    this.sendMessageType(messageType)
  }
  sendMessageType(messageType) {
    if (messageType) {
      this.broadcast(messageType)
    }
  }
  /**
     * Включено ручное управление
     * @since 1.8.0
     *
     * @param {() => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof DriveService
     *
     * @example <caption>Включено ручное управление</caption>
     * robot.driveService.onDriveModeManual(() => {
     *   // ...
     * })
     */
  onDriveModeManual(callback) {
    return this.subscribe(DriveMessageType.DRIVE_MODE_MANUAL, callback)
  }
  /**
     * Включено автономное передвижение
     * @since 1.8.0
     *
     * @param {() => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof DriveService
     *
     * @example <caption>Включено автономное передвижение</caption>
     * robot.driveService.onDriveModeAuto(() => {
     *   // ...
     * })
     */
  onDriveModeAuto(callback) {
    return this.subscribe(DriveMessageType.DRIVE_MODE_AUTO, callback)
  }
  /**
     * Ожидание передвижения
     * @since 1.8.0
     *
     * @param {() => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof DriveService
     *
     * @example <caption>Ожидание передвижения</caption>
     * robot.driveService.onIdle(() => {
     *   ...
     * })
     */
  onIdle(callback) {
    return this.subscribe(DriveMessageType.DRIVE_STATUS_IDLE, callback)
  }
  /**
     * Робот начал передвижение
     * @since 1.8.0
     *
     * @param {() => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof DriveService
     *
     * @example <caption>начало передвижения</caption>
     * robot.driveService.onStart(() => {
     *   ...
     * })
     */
  onStart(callback) {
    return this.subscribe(DriveMessageType.DRIVE_STATUS_START, callback)
  }
  /**
     * Перед роботом препятствиe
     * @since 1.8.0
     *
     * @param {() => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof DriveService
     *
     * @example <caption>Перед роботом препятствиe</caption>
     * robot.driveService.onObstacle(() => {
     *   ...
     * })
     */
  onObstacle(callback) {
    return this.subscribe(DriveMessageType.DRIVE_STATUS_OBSTACLE, callback)
  }
  /**
     * Передвижение отменено
     * @since 1.8.0
     *
     * @param {() => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof DriveService
     *
     * @example <caption>Передвижение отменено</caption>
     * robot.driveService.onCancel(() => {
     *   ...
     * })
     */
  onCancel(callback) {
    return this.subscribe(DriveMessageType.DRIVE_STATUS_CANCEL, callback)
  }
  /**
     * Передвижение окончено
     * @since 1.8.0
     *
     * @param {() => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof DriveService
     *
     * @example <caption>Передвижение окончено</caption>
     * robot.driveService.onFinish(() => {
     *   ...
     * })
     */
  onFinish(callback) {
    return this.subscribe(DriveMessageType.DRIVE_STATUS_FINISH, callback)
  }
  /**
     * Робот ожидает завершение передвижения к зарядной станции
     * @since 1.8.0
     *
     * @param {() => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof DriveService
     *
     * @example <caption>ожидаем завершение передвижения к зарядной станции</caption>
     * robot.driveService.onChargeIdle(() => {
     *   // ...
     * })
     */
  onChargeIdle(callback) {
    return this.subscribe(DriveMessageType.DRIVE_CHARGE_STATUS_IDLE, callback)
  }
  /**
     * Не удалось найти метку зарядной станции
     * @since 1.8.0
     *
     * @param {() => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof DriveService
     *
     * @example <caption>Не удалось найти метку зарядной станции</caption>
     * robot.driveService.onChargeFailFindMarker(() => {
     *   // ...
     * })
     */
  onChargeFailFindMarker(callback) {
    return this.subscribe(DriveMessageType.DRIVE_CHARGE_STATUS_FAIL_FIND_MARKER, callback)
  }
  /**
     * Робот успешно достиг зарядной станции
     * @since 1.8.0
     *
     * @param {() => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof DriveService
     *
     * @example <caption>Робот успешно достиг зарядной станции</caption>
     * robot.driveService.onChargeSuccessful(() => {
     *   // ...
     * })
     */
  onChargeSuccessful(callback) {
    return this.subscribe(DriveMessageType.DRIVE_CHARGE_STATUS_SUCCESS, callback)
  }
  /**
     * Не удалось подсоединиться к зарядной станции
     * @since 1.8.0
     *
     * @param {() => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof DriveService
     *
     * @example <caption>Не удалось подсоединиться к зарядной станции</caption>
     * robot.driveService.onChargeFailConnect(() => {
     *   // ...
     * })
     */
  onChargeFailConnect(callback) {
    return this.subscribe(DriveMessageType.DRIVE_CHARGE_STATUS_FAIL_CONNECT, callback)
  }
  /**
     * Передать запрос на передвижение в точку на навигационной карте
     * @since 1.8.0
     *
     * @param {number} point - точка назначения для передвижения по навигационной карте
     * @memberof DriveService
     *
     * @example <caption>Передать запрос на передвижение в точку на навигационной карте</caption>
     * robot.driveService.driveToPoint(point)
     */
  driveToPoint(point) {
    this.messageChannel.send({
      type: ApiDriveMessageType.DRIVE_CONTROL,
      drive_point: point,
    })
  }
  /**
     * Передать запрос на приостановку передвижения
     * @since 1.8.0
     *
     * @param {boolean} status - True для паузы и False для продолжения передвижения
     * @memberof DriveService
     *
     * @example <caption>Передать запрос на приостановку передвижения</caption>
     * robot.driveService.drivePause(status)
     */
  drivePause(status) {
    this.messageChannel.send({
      type: ApiDriveMessageType.DRIVE_CONTROL,
      drive_pause: status,
    })
  }
  /**
     * Задать текущий режим передвижения
     * @since 1.8.0
     *
     * @param {DriveMode} mode
     * @memberof DriveService
     *
     * @example <caption>Задать текущий режим передвижения</caption>
     * robot.driveService.driveMode(mode)
     */
  driveMode(mode) {
    this.messageChannel.send({
      type: ApiDriveMessageType.DRIVE_CONTROL,
      drive_mode: mode,
    })
  }
  /**
     * Передать запрос на передвижение к зарядной станции
     * @since 1.8.0
     *
     * @param {boolean} status - True для начала и False для завершения передвижения
     * @memberof DriveService
     *
     * @example <caption>Передать запрос на передвижение к зарядной станции</caption>
     * robot.driveService.driveCharger(status)
     */
  driveCharger(status) {
    this.messageChannel.send({
      type: ApiDriveMessageType.DRIVE_CONTROL,
      drive_charger: status,
    })
  }
}
